export default context => {
    context.commit('appState/RESET_EMPLOYER', null, {
        root: true,
    });
};